export default [
  {
    id: 1,
    time: {
      short: '00:00',
      long: '00:00 - 00:30'
    }
  }, {
    id: 2,
    time: {
      short: '00:30',
      long: '00:30 - 01:00'
    }
  }, {
    id: 3,
    time: {
      short: '01:00',
      long: '01:00 - 01:30'
    }
  }, {
    id: 4,
    time: {
      short: '01:30',
      long: '01:30 - 02:00'
    }
  }, {
    id: 5,
    time: {
      short: '02:00',
      long: '02:00 - 02:30'
    }
  }, {
    id: 6,
    time: {
      short: '02:30',
      long: '02:30 - 03:00'
    }
  }, {
    id: 7,
    time: {
      short: '03:00',
      long: '03:00 - 03:30'
    }
  }, {
    id: 8,
    time: {
      short: '03:30',
      long: '03:30 - 04:00'
    }
  }, {
    id: 9,
    time: {
      short: '04:00',
      long: '04:00 - 04:30'
    }
  }, {
    id: 10,
    time: {
      short: '04:30',
      long: '04:30 - 05:00'
    }
  }, {
    id: 11,
    time: {
      short: '05:00',
      long: '05:00 - 05:30'
    }
  }, {
    id: 12,
    time: {
      short: '05:30',
      long: '05:30 - 06:00'
    }
  }, {
    id: 13,
    time: {
      short: '06:00',
      long: '06:00 - 06:30'
    }
  }, {
    id: 14,
    time: {
      short: '06:30',
      long: '06:30 - 07:00'
    }
  }, {
    id: 15,
    time: {
      short: '07:00',
      long: '07:00 - 07:30'
    }
  }, {
    id: 16,
    time: {
      short: '07:30',
      long: '07:30 - 08:00'
    }
  }, {
    id: 17,
    time: {
      short: '08:00',
      long: '08:00 - 08:30'
    }
  }, {
    id: 18,
    time: {
      short: '08:30',
      long: '08:30 - 09:00'
    }
  }, {
    id: 19,
    time: {
      short: '09:00',
      long: '09:00 - 09:30'
    }
  }, {
    id: 20,
    time: {
      short: '09:30',
      long: '09:30 - 10:00'
    }
  }, {
    id: 21,
    time: {
      short: '10:00',
      long: '10:00 - 10:30'
    }
  }, {
    id: 22,
    time: {
      short: '10:30',
      long: '10:30 - 11:00'
    }
  }, {
    id: 23,
    time: {
      short: '11:00',
      long: '11:00 - 11:30'
    }
  }, {
    id: 24,
    time: {
      short: '11:30',
      long: '11:30 - 12:00'
    }
  }, {
    id: 25,
    time: {
      short: '12:00',
      long: '12:00 - 12:30'
    }
  }, {
    id: 26,
    time: {
      short: '12:30',
      long: '12:30 - 13:00'
    }
  }, {
    id: 27,
    time: {
      short: '13:00',
      long: '13:00 - 13:30'
    }
  }, {
    id: 28,
    time: {
      short: '13:30',
      long: '13:30 - 14:00'
    }
  }, {
    id: 29,
    time: {
      short: '14:00',
      long: '14:00 - 14:30'
    }
  }, {
    id: 30,
    time: {
      short: '14:30',
      long: '14:30 - 15:00'
    }
  }, {
    id: 31,
    time: {
      short: '15:00',
      long: '15:00 - 15:30'
    }
  }, {
    id: 32,
    time: {
      short: '15:30',
      long: '15:30 - 16:00'
    }
  }, {
    id: 33,
    time: {
      short: '16:00',
      long: '16:00 - 16:30'
    }
  }, {
    id: 34,
    time: {
      short: '16:30',
      long: '16:30 - 17:00'
    }
  }, {
    id: 35,
    time: {
      short: '17:00',
      long: '17:00 - 17:30'
    }
  }, {
    id: 36,
    time: {
      short: '17:30',
      long: '17:30 - 18:00'
    }
  }, {
    id: 37,
    time: {
      short: '18:00',
      long: '18:00 - 18:30'
    }
  }, {
    id: 38,
    time: {
      short: '18:30',
      long: '18:30 - 19:00'
    }
  }, {
    id: 39,
    time: {
      short: '19:00',
      long: '19:00 - 19:30'
    }
  }, {
    id: 40,
    time: {
      short: '19:30',
      long: '19:30 - 20:00'
    }
  }, {
    id: 41,
    time: {
      short: '20:00',
      long: '20:00 - 20:30'
    }
  }, {
    id: 42,
    time: {
      short: '20:30',
      long: '20:30 - 21:00'
    }
  }, {
    id: 43,
    time: {
      short: '21:00',
      long: '21:00 - 21:30'
    }
  }, {
    id: 44,
    time: {
      short: '21:30',
      long: '21:30 - 22:00'
    }
  }, {
    id: 45,
    time: {
      short: '22:00',
      long: '22:00 - 22:30'
    }
  }, {
    id: 46,
    time: {
      short: '22:30',
      long: '22:30 - 23:00'
    }
  }, {
    id: 47,
    time: {
      short: '23:00',
      long: '23:00 - 23:30'
    }
  }, {
    id: 48,
    time: {
      short: '23:30',
      long: '23:30 - 00:00'
    }
  }
]
